export { default as linux } from './linux.png';
export { default as windows } from './windows.png';
export { default as macos } from './apple.png';
export { default as android } from './android.svg';



// WEBPACK FOOTER //
// ./src/components/ApplicationTable/icons/index.js